<div class="container-fluid mt-2 contact-us">
    <div class="row">
    <div class="col-12">
    <div class="header">Contact Us</div>
    <div class="fieldheader">Support</div>
    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="margin-bottom:10px;">
    <tr>
    <td width="50%">Phone: 1-866-287-4987<br/>
    Email: support&#64;matrixcare.com
    </td>
    </tr>
    </table>
    <div style="margin-bottom:10px;"><A class="submitbutton" name="Submit" target="_blank" href="http://www.matrixcare.com/support-and-services/support-form/">Submit a support request</A></div>
    <div class="fieldheader">Address</div>
    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="margin-bottom:10px;">
    <tr>
    <td width="50%">MatrixCare<br/>
    10900 Hampshire Ave South, Suite 100<br/>
    Bloomington, MN 55438<br/><br/>
    Toll Free: 1-800-869-1322<br/>
    Direct: 952-995-9800<br/>
    Fax: 952-995-9735<br/>
    URL: <A target="_blank" href="http://www.matrixcare.com">http://www.matrixcare.com</A>/<br/><br/>
    </td>
    </tr>
    </table>
    <div class="fieldheader">MatrixCare Help Desk</div>
    <div style="margin-bottom:10px;">You can <A target="_blank" href="https://get.teamviewer.com/matrixcare">Launch Remote Support</A> if your support representative has directed you to do so.</div>
    <div style="margin-top:100px;" id="yearDiv" align="center">&copy; Copyright 2002-{{copyrightYear}} MatrixCare.<br/>All Rights Reserved.</div>
    </div>
    </div>
   </div>
